import { InputNumber } from 'antd'
import "./LongitudeLatitudeForm.scss"
import { useEffect, useState } from 'react'

export const LongitudeLatitudeInput = ({ value, onChange, type }) => {
    const [inputValue, setInputValue] = useState('')

    const handleChange = e => {
        const result = e
        setInputValue(result)
    }

     useEffect(() => {
         setInputValue(value)
     }, [])

    useEffect(() => {
        onChange(inputValue)
    }, [inputValue])

    return (
        <InputNumber
            value={inputValue}
            className='LongitudeLatitudeInput'
            precision={5} // 设置显示的小数位数为5
            min={type === 'longitude' ? -180 : -90}
            max={type === 'longitude' ? 180 : 90}
            onChange={handleChange}
        />
    )
}
